import React from 'react'
import { createRoot } from 'react-dom/client'
import Routes from 'routes'
import { configure } from 'react-hotkeys'
import fontAwesome from 'utils/fontAwesome'
import * as Sentry from '@sentry/react'
import { ApiResponseError } from 'utils/_utils/apiResponseError'
import { StaleChunkError } from 'utils/_utils/lazyWithRetry'
import 'styles'

fontAwesome.initLibrary()

configure({
  ignoreRepeatedEventsWhenKeyHeldDown: false,
  allowCombinationSubmatches: true,
})

if (import.meta.env.PROD && ['stage', 'replica', 'production'].includes(import.meta.env.VITE_APP_ENV)) {
  const environment = String(import.meta.env.VITE_APP_ENV)

  Sentry.init({
    dsn: 'https://f3407004694b476fac67550f4d58e81f@o117841.ingest.us.sentry.io/1397907',
    release: APP_VERSION,
    environment,
    beforeSend(event, hint) {
      // Filter out API (400, 404, 403 ...) errors
      if (hint.originalException instanceof ApiResponseError) {
        return null
      }

      // Stale chunk errors are expected after a new deployment and handled
      // by ErrorBoundary (modal prompts a reload) — don't spam Sentry.
      if (hint.originalException instanceof StaleChunkError) {
        return null
      }

      // Filter out Auth0 errors, mapbox-gl internals, network/API failures &
      // other known non-actionable errors.
      const message = hint.originalException instanceof Error ? hint.originalException.message : ''
      if (
        message.includes('Unknown Geometry Type') ||
        message.includes('Invalid state') ||
        message.includes('Login Required') ||
        message.includes('errorCb is not a function') ||
        message.includes('A new version of the app is available') ||
        message.startsWith('Unable to download data from Semios API endpoint:') ||
        message.startsWith('Failed to fetch')
      ) {
        return null
      }

      return event
    },
  })
}

const root = createRoot(document.getElementById('root') as HTMLElement)
root.render(<Routes />)
